export default __webpack_public_path__ + "static/media/value1.ae6b325d.svg";